namespace GeniuzPOS.LogManage {
    export class LogRefundColumns {
        static columnsKey = 'LogManage.LogRefund';
    }
}
